const pawport = {
  openDrawer(id) {
    const drawer = document.querySelector(`.drawer-overlay[data-drawer-id="${id}"]`);
    if (drawer) {
      drawer.setAttribute('data-status', 'open');
      drawer.classList.add('open');
      document.body.classList.add('no-scroll');
    }
  },

  closeDrawer(id) {
    const drawer = document.querySelector(`.drawer-overlay[data-drawer-id="${id}"]`);
    if (drawer) {
      drawer.setAttribute('data-status', 'closed');
      drawer.classList.remove('open');
      document.body.classList.remove('no-scroll');
    }
  },

  openModal(id) {
    const modal = document.querySelector(`.modal[data-modal-id="${id}"]`);
    if (modal) {
      modal.setAttribute('data-status', 'open');
      modal.classList.add('open');
      document.body.classList.add('no-scroll');
    }
  },

  closeModal(id) {
    const modal = document.querySelector(`.modal[data-modal-id="${id}"]`);
    if (modal) {
      modal.setAttribute('data-status', 'closed');
      modal.classList.remove('open');
      document.body.classList.remove('no-scroll');
    }
  },
};
